import DropdownFilterGenerator from './Components/DropdownFilterGenerator';

export default DropdownFilterGenerator();
